export default __webpack_public_path__ + "static/media/Tanya_img.ff448fd5.jpg";